import Vue from 'vue'
import Router from 'vue-router'
import JWT from '@/utils/jwt'
import { EMAIL_PUBLIC, PASS_PUBLIC } from '@/store/auth/constants'
import { login } from '@/store/auth/api'
import store from '@/store'

Vue.use(Router)

let router = new Router({
    mode: 'history',
    //base: process.env.BASE_URL,
    routes: [{
            path: '/',
            name: 'home',
            meta: {
                layout: 'guest',
                guest: true
            },
            component: () =>
                import ( /* webpackChunkName: "home" */ "@/modules/home/_views/Home"),
        },
        // Pages
        {
            path: '/huong-dan-su-dung',
            name: 'guide-page',
            meta: {
                layout: 'guest',
                guest: true,
                hideFooter: true,
                hideHeader: true
            },
            component: () =>
                import ( /* webpackChunkName: "page-about" */ "@/views/pages/GuideApp"),
        },
        {
            path: '/gioi-thieu',
            name: 'page-about',
            meta: {
                layout: 'guest',
                guest: true
            },
            component: () =>
                import ( /* webpackChunkName: "page-about" */ "@/views/pages/About"),
        },
        {
            path: '/ho-tro',
            name: 'page-support',
            meta: {
                layout: 'guest',
                guest: true
            },
            component: () =>
                import ( /* webpackChunkName: "page-support" */ "@/views/pages/Support"),
        },
        {
            path: '/trung-tam-tro-giup',
            name: 'tro-giup',
            meta: {
                layout: 'guest'
            },
            component: () =>
                import ( /* webpackChunkName: "page-about" */ "@/views/pages/HelpCenter"),
        },

        {
            path: '/chinh-sach-bao-mat',
            name: 'bao-mat',
            meta: {
                layout: 'guest'
            },
            component: () =>
                import ( /* webpackChunkName: "page-about" */ "@/views/pages/PrivacyPolicy"),
        },

        {
            path: '/dieu-khoan',
            name: 'dieu-khoan',
            meta: {
                layout: 'guest'
            },
            component: () =>
                import ( /* webpackChunkName: "page-about" */ "@/views/pages/Rules"),
        },
        {
            path: '/kiem-tra-xac-thuc',
            name: 'kiem-tra-xac-thuc',
            meta: {
                layout: 'guest',
                guest: true
            },
            component: () =>
                import ( /* webpackChunkName: "home" */ "@/views/pages/keycloak"),
        },
        // EBook
        {
            path: '/sach-dien-tu',
            name: 'ebook',
            // meta: { requiresAuth: true },
            meta: {
                layout: 'default'
            },
            component: () =>
                import ( /* webpackChunkName: "ebook-list" */ "@/modules/ebooks"),
            props: {
                template: "EBookList"
            },
            query: {
                book_active: 0,
                classes_active: 1
            }
        },
        {
            path: '/danh-sach-lop-hoc',
            name: 'classSchool',
            // meta: { requiresAuth: true },
            meta: {
                layout: 'default'
            },
            component: () =>
                import ( "@/modules/class-school/member"),
        },
        {
            path: '/chi-tiet-lop-hoc-trang-ca-nhan',
            name: 'classSchool',
            // meta: { requiresAuth: true },
            meta: {
                layout: 'default'
            },
            component: () =>
                import ( "@/modules/class-school/member/detail_class_member_personal_page"),
        },
        {
            path: '/lop-hoc-cua-toi',
            name: 'classSchool',
            // meta: { requiresAuth: true },
            meta: {
                layout: 'default'
            },
            component: () =>
                import ( "@/modules/class-school/member/my_class_school"),
        },
        {
            path: '/trang-ca-nhan-giao-vien',
            name: 'classSchool',
            // meta: { requiresAuth: true },
            meta: {
                layout: 'default'
            },
            component: () =>
                import ( "@/modules/class-school/teacher_personal_page"),
        },
        {
            path: '/chi-tiet-bai-giang-dien-tu-da-giao',
            name: 'classSchool',
            // meta: { requiresAuth: true },
            props: true,
            meta: {
                layout: 'default'
            },
            component: () =>
                import ("@/modules/class-school/teacher_personal_page/detail_electronic_lecture_assigned"),
        },
        {
            path: '/chi-tiet-bai-kiem-tra-da-giao',
            name: 'classSchool',
            // meta: { requiresAuth: true },
            props: true,
            meta: {
                layout: 'default'
            },
            component: () =>
                import ( "@/modules/class-school/teacher_personal_page/detail_exercise_assigned"),
        },
        {
            path: '/chi-tiet-ke-hoach-bai-day-da-giao',
            name: 'classSchool',
            // meta: { requiresAuth: true },
            props: true,
            meta: {
                layout: 'default'
            },
            component: () =>
                import ("@/modules/class-school/teacher_personal_page/detail_lesson_plan_assigned"),
        },
        {
            path: '/bai-giang-dien-tu/thong-tin-bai-giang',
            name: 'classSchool',
            // meta: { requiresAuth: true },
            meta: {
                layout: 'default'
            },
            component: () =>
                import ("@/modules/class-school/member/electronic_lecture/ContentElectronicLecture"),
        },
        {
            path: '/ke-hoach-bai-day/thong-tin-bai-day',
            name: 'prepareDocuments',
            // meta: { requiresAuth: true },
            meta: {
                layout: 'default'
            },
            component: () =>
                import ( "@/modules/class-school/member/lesson_planing/ContentLessonPlaning"),
        },
        {
            path: '/lop-hoc',
            name: 'classSchool',
            // meta: { requiresAuth: true },
            meta: {
                layout: 'default'
            },
            component: () =>
                import ( "@/modules/class-school/teacher"),
        },
        {
            path: '/tham-gia-lop-hoc',
            name: 'joinClassSchool',
            // meta: { requiresAuth: true },
            meta: {
                layout: 'default'
            },
            component: () =>
                import ("@/modules/class-school/page/link_join_class_school"),
        },
        {
            path: '/soan-tai-lieu',
            name: 'prepareDocuments',
            // meta: { requiresAuth: true },
            meta: {
                layout: 'default'
            },
            component: () =>
                import ("@/modules/class-school/teacher_prepare_document"),
        },
        {
            path: '/noi-dung-de-thi-chua-cham',
            name: 'prepareDocuments',
            // meta: { requiresAuth: true },
            meta: {
                layout: 'default'
            },
            component: () =>
                import ("@/modules/class-school/teacher_prepare_document/excercise_component/ContentExcerciseNotScore"),
        },
        {
            path: '/lam-de-kiem-tra',
            name: 'pageStartExcercise',
            // meta: { requiresAuth: true },
            meta: {
                layout: 'default'
            },
            component: () =>
                import ("@/modules/class-school/member/excercise_class_school/PageStartExcercise"),
        },
        {
            path: '/lam-de-kiem-tra/bat-dau-lam-bai',
            name: 'pageStartExcercise',
            // meta: { requiresAuth: true },
            meta: {
                layout: 'default'
            },
            component: () =>
                import ("@/modules/class-school/member/excercise_class_school/PageDoExcercise"),
        },
        {
            path: '/tao-bai-kiem-tra',
            name: 'prepareDocuments',
            // meta: { requiresAuth: true },
            meta: {
                layout: 'default'
            },
            component: () =>
                import ("@/modules/class-school/teacher_prepare_document/excercise_component/PageViewCreateExcercise"),
        },
        {
            path: '/tao-de-ngan-hang-de',
            name: 'prepareDocuments',
            // meta: { requiresAuth: true },
            meta: {
                layout: 'default'
            },
            component: () =>
                import ("@/modules/class-school/teacher_prepare_document/excercise_component/PageCreateTopicBank"),
        },
        {
            path: '/de-thi-da-giao',
            name: 'prepareDocuments',
            // meta: { requiresAuth: true },
            meta: {
                layout: 'default'
            },
            component: () =>
                import ("@/modules/class-school/teacher_prepare_document/excercise_component/PageDetailExcerciseAssign"),
        },
        {
            path: '/kho-bai-giang/bai-giang-dien-tu',
            name: 'prepareDocuments',
            // meta: { requiresAuth: true },
            meta: {
                layout: 'default'
            },
            component: () =>
                import ("@/modules/class-school/teacher_prepare_document/lesson_component/DetailElectronicLectureWarehouse"),
        },
        {
            path: '/kho-ke-hoach-bay-day/ke-hoach-bai-day',
            name: 'prepareDocuments',
            // meta: { requiresAuth: true },
            meta: {
                layout: 'default'
            },
            component: () =>
                import ("@/modules/class-school/teacher_prepare_document/lesson_component/DetailLessonPlaningWarehouse"),
        },
       
        {
            path: '/ke-hoach-da-giao',
            name: 'DetailLessonPlaningDelivered',
            // meta: { requiresAuth: true },
            meta: {
                layout: 'default'
            },
            component: () =>
                import ("@/modules/class-school/teacher_prepare_document/lesson_component/DetailLessonPlaningDelivered"),
        },
        {
            path: '/bai-giang-dien-tu-da-giao',
            name: 'ElectronicLecturesDelivered',
            // meta: { requiresAuth: true },
            meta: {
                layout: 'default'
            },
            component: () =>
                import ("@/modules/class-school/teacher_prepare_document/lesson_component/ElectronicLecturesDelivered"),
        },
        //bai-giang-dien-tu
        {
            path: '/bai',
            name: 'prepareDocuments',
            // meta: { requiresAuth: true },
            meta: {
                layout: 'default'
            },
            component: () =>
                import ("@/modules/class-school/teacher_prepare_document"),
        },
        {
            path: '/lam-bai-kiem-tra',
            name: 'takeExcerciseClassSchool',
            // meta: { requiresAuth: true },
            meta: {
                layout: 'default'
            },
            component: () =>
                import ("@/modules/class-school/page/page_excercise_class_school"),
        },
        {
            path: '/quan-ly-lop-hoc',
            name: 'classSchoolManager',
            // meta: { requiresAuth: true },
            meta: {
                layout: 'default'
            },
            component: () =>
                import ( "@/modules/class-school/teacher/manager_class_school"),
        },
        {
            path: '/thong-ke-hoc-sinh',
            name: 'MemberPersonal',
            // meta: { requiresAuth: true },
            meta: {
                layout: 'default'
            },
            component: () =>
                import ("@/modules/class-school/teacher/page_member_personal"),
        },
        {
            path: '/sach-dien-tu/:slug-:id(\\d+)',
            name: 'ebook-detail',
            meta: {
                layout: 'default'
            },
            // meta: { requiresAuth: true },
            component: () =>
                import ( /* webpackChunkName: "ebook-list" */ "@/modules/ebooks"),
            props: {
                template: "EBookDetail"
            }
        },
        {
            path: '/ebook/r/:slug-:id(\\d+)',
            name: 'ebook-detail-read',
            meta: {
                layout: 'simple'
            },
            // meta: { requiresAuth: true },
            component: () =>
                import ( /* webpackChunkName: "ebook-list" */ "@/modules/ebooks"),
            props: {
                template: "EBookDetailRead"
            }
        },
        {
            path: '/ebook/r2/:slug-:id(\\d+)',
            name: 'ebook-detail-read-2',
            meta: {
                layout: 'simple'
            },
            // meta: { requiresAuth: true },
            component: () =>
                import ( /* webpackChunkName: "ebook-list" */ "@/modules/ebooks"),
            props: {
                template: "EBookDetailRead2"
            }
        },
        {
            path: '/ebook/read/:slug-:id(\\d+)',
            name: 'ebook-read-book',
            meta: {
                layout: 'onlybody',
                hideHeader: true
            },
            // meta: { requiresAuth: true },
            component: () =>
                import ( /* webpackChunkName: "ebook-list" */ "@/modules/ebooks"),
            props: {
                template: "EBookReadBook2"
            },
            query: {
                page: 0
            }
        },
        // {
        //     path: '/ebook/test',
        //     name: 'test',
        //     meta: { layout: 'simple', hideHeader: true },
        //     // meta: { requiresAuth: true },
        //     component: () =>
        //         import ( /* webpackChunkName: "ebook-list" */ "@/modules/ebooks"),
        //     props: {
        //         template: "test"
        //     }
        // },

        {
            path: '/bo-sach-:id(\\d+)',
            name: 'ebook-group',
            meta: {
                layout: 'default'
            },
            // meta: { requiresAuth: true },
            component: () =>
                import ( /* webpackChunkName: "ebook-list" */ "@/modules/ebooks"),
            props: {
                template: "BookGroup"
            }
        },
        {
            path: '/ebook-class/class-:id(\\d+)',
            name: 'ebook-type',
            meta: {
                layout: 'default'
            },
            // meta: { requiresAuth: true },
            component: () =>
                import ( /* webpackChunkName: "ebook-list" */ "@/modules/ebooks"),
            props: {
                template: "EBookType"
            }
        },
        {
            path: '/sach-dien-tu-bo-:typeId-lop-:classId-loai-:groupId',
            name: 'ebook-view-all',
            meta: {
                layout: 'default'
            },
            // meta: { requiresAuth: true },
            component: () =>
                import ( /* webpackChunkName: "ebook-list" */ "@/modules/ebooks"),
            props: {
                template: "EBookType"
            }
        },
        {
            path: '/ebook-classes/class-:id(\\d+)',
            name: 'ebook-classes',
            meta: {
                layout: 'default'
            },
            // meta: { requiresAuth: true },
            component: () =>
                import ( /* webpackChunkName: "ebook-list" */ "@/modules/ebooks"),
            props: {
                template: "EBookType"
            }
        },
        {
            path: '/ebook-type/class-:typeId(\\d+)-:id(\\d+)',
            name: 'ebook-class',
            // meta: { requiresAuth: true },
            component: () =>
                import ( /* webpackChunkName: "ebook-list" */ "@/modules/ebooks"),
            props: {
                template: "EBookClasses"
            }
        },
        {
            path: '/ebook/:slug-:id(\\d+)',
            name: 'ebook-info',
            // meta: { requiresAuth: true },
            component: () =>
                import ( /* webpackChunkName: "ebook-info" */ "@/modules/ebooks"),
            props: {
                template: "EBookInfo"
            }
        },
        // exercise
        {
            path: '/luyen-tap',
            name: 'exercise',
            // meta: { requiresAuth: true },
            meta: {
                layout: 'default'
            },
            component: () =>
                import ( /* webpackChunkName: "ebook-list" */ "@/modules/exercises"),
            props: {
                template: "ExerciseList"
            },
            query: {
                lop: 0,
                mon: 0,
                tab: 0
            }
        },

        // library
        {
            path: '/thu-vien',
            name: 'library',
            // meta: { requiresAuth: true },
            meta: {
                layout: 'default'
            },
            component: () =>
                import ( /* webpackChunkName: "ebook-list" */ "@/modules/libraries"),
            props: {
                template: "ViewLibrary"
            },
            query: {
                lop: 0,
                mon: 0,
                nhom: 0,
                sach: 0,
                tab: 0
            }
        },
        // {
        //     path: '/thu-vien/mon-hoc',
        //     name: 'ViewDetailBooks',
        //     // meta: { requiresAuth: true },
        //     meta: { layout: 'simple', hideHeader: true, hideFooter: true },
        //     component: () =>
        //         import ( /* webpackChunkName: "ebook-list" */ "@/modules/libraries"),
        //     props: {
        //         template: "ViewDetailBooks"
        //     },
        //     query: {

        //     }
        // },
        {
            path: '/thu-vien/xem-tat-ca-:type-:id-:classId(\\d+)',
            name: 'LibraryAll',
            // meta: { requiresAuth: true },
            meta: {
                layout: 'default'
            },
            component: () =>
                import ( /* webpackChunkName: "ebook-list" */ "@/modules/libraries"),
            props: {
                template: "LibraryAll"
            },
            query: {}
        },

        {
            path: '/thu-vien/sach/:book-:type-:subjectId-:classId',
            name: 'LibraryAllOfBook',
            // meta: { requiresAuth: true },
            meta: {
                layout: 'default'
            },
            component: () =>
                import ( /* webpackChunkName: "ebook-list" */ "@/modules/libraries"),
            props: {
                template: "LibraryAllOfBook"
            },
            query: {

            }
        },

        {
            path: '/thu-vien/bai-giang-dien-tu/:id',
            name: 'libraryLessonDetail',
            // meta: { requiresAuth: true },
            meta: {
                layout: 'simple',
                hideHeader: true
            },
            component: () =>
                import ( /* webpackChunkName: "ebook-list" */ "@/modules/libraries"),
            props: {
                template: "DetailLesson"
            }
        },

        {
            path: '/thu-vien/bai-hoc-chu-dong/:id',
            name: 'DetailPageActiveLearn',
            // meta: { requiresAuth: true },
            meta: {
                layout: 'default',
                // hideHeader: true
            },
            component: () =>
                import ( /* webpackChunkName: "ebook-list" */ "@/modules/libraries"),
            props: {
                template: "DetailActiveLearn"
            }
        },

        {
            path: '/thu-vien/hoc-lieu-dien-tu/:id',
            name: 'DetailPageLinkLib',
            // meta: { requiresAuth: true },
            meta: {
                layout: 'default'
            },
            component: () =>
                import ( /* webpackChunkName: "ebook-list" */ "@/modules/libraries"),
            props: {
                template: "DetailPageLinkLib"
            }
        },
        // {
        //     path: '/sach-dien-tu',
        //     name: 'ebook',
        //     // meta: { requiresAuth: true },
        //     meta: { layout: 'default' },
        //     component: () =>
        //         import ( /* webpackChunkName: "ebook-list" */ "@/modules/ebooks"),
        //     props: {
        //         template: "EBookList"
        //     },
        //     query: {
        //         book_active: 0
        //     }
        // },
        {
            path: '/luyen-tap/lop:classId/mon/:subjectId',
            name: 'exerciseSubject',
            // meta: { requiresAuth: true },
            meta: {
                layout: 'simple'
            },
            component: () =>
                import ( /* webpackChunkName: "ebook-list" */ "@/modules/exercises"),
            props: {
                template: "ExerciseSubject"
            },
        },
        {
            path: '/luyen-tap/sach/:bookId',
            name: 'exerciseByEbooks',
            // meta: { requiresAuth: true },
            meta: {
                layout: 'simple'
            },
            component: () =>
                import ( /* webpackChunkName: "ebook-list" */ "@/modules/exercises"),
            props: {
                template: "ExerciseEbook"
            }
        },
        {
            path: '/luyen-tap/lam-bai/:bookId-:subjectId-:questionId(\\d+)',
            name: 'exerciseExam',
            // meta: { requiresAuth: true },
            meta: {
                layout: 'simple',
                hideHeader: true,
                hideFooter: true
            },
            component: () =>
                import ( /* webpackChunkName: "ebook-list" */ "@/modules/exercises"),
            props: {
                template: "ExerciseExam"
            }
        },
        {
            path: '/luyen-tap/cau-hoi/:classId-:subjectId-:bookType-:practiceType(\\d+)',
            name: 'exerciseDetail',
            // meta: { requiresAuth: true },
            meta: {
                layout: 'onlybody',
                hideHeader: true,
                hideFooter: true
            },
            component: () => import ( /* webpackChunkName: "ebook-list" */ "@/modules/exercises"),
            props: {
                template: "ExerciseDetail"
            }
        },
        {
            path: '/luyen-tap/chuyen-de/cau-hoi/:classId-:subjectId-:typeId-:id-:question(\\d+)',
            name: 'exerciseThematicQuestion',
            // meta: { requiresAuth: true },
            meta: {
                layout: 'simple',
                hideHeader: true,
                hideFooter: true
            },
            component: () => import ( /* webpackChunkName: "ebook-list" */ "@/modules/exercises"),
            props: {
                template: "ThematicQuestion"
            }
        },
        {
            path: '/luyen-tap/chuyen-de/:classId-:subjectId-:typeId-:id(\\d+)',
            name: 'exerciseThematicDetail',
            // meta: { requiresAuth: true },
            meta: {
                layout: 'simple',
                hideHeader: true,
                hideFooter: true
            },
            component: () => import ( /* webpackChunkName: "ebook-list" */ "@/modules/exercises"),
            props: {
                template: "ThematicDetail"
            },
            query: {
                cauhoi: 0
            }
        },
        {
            path: '/luyen-tap/luyen-tap-khac/cau-hoi/:classId-:subjectId-:typeId-:id-:question(\\d+)',
            name: 'exerciseOtherQuestion',
            // meta: { requiresAuth: true },
            meta: {
                layout: 'simple',
                hideHeader: true,
                hideFooter: true
            },
            component: () => import ( /* webpackChunkName: "ebook-list" */ "@/modules/exercises"),
            props: {
                template: "OtherQuestion"
            }
        },
        {
            path: '/luyen-tap/luyen-tap-khac/:classId-:subjectId-:typeId-:id(\\d+)',
            name: 'exerciseOtherDetail',
            // meta: { requiresAuth: true },
            meta: {
                layout: 'onlybody',
                hideHeader: true,
                hideFooter: true
            },
            component: () => import ( /* webpackChunkName: "ebook-list" */ "@/modules/exercises"),
            props: {
                template: "OtherDetail"
            },
            query: {
                cauhoi: 1
            }
        },
        {
            path: '/luyen-tap/de-thi/cau-hoi/ket-qua/:id(\\d+)',
            name: 'exerciseExamResult',
            // meta: { requiresAuth: true },
            meta: {
                layout: 'simple',
                hideHeader: true,
                hideFooter: true
            },
            component: () => import ( /* webpackChunkName: "ebook-list" */ "@/modules/exercises"),
            props: {
                template: "ExamResult"
            }
        },
        {
            path: '/luyen-tap/de-thi/cau-hoi/:classId-:subjectId-:id(\\d+)',
            name: 'exerciseExamQuestion',
            // meta: { requiresAuth: true },
            meta: {
                layout: 'onlybody',
                hideHeader: true,
                hideFooter: true
            },
            component: () => import ( /* webpackChunkName: "ebook-list" */ "@/modules/exercises"),
            props: {
                template: "ExamQuestion"
            }
        },
        {
            path: '/luyen-tap/danh-sach-de-thi/:classId-:subjectId(\\d+)',
            name: 'exerciseExamList',
            // meta: { requiresAuth: true },
            meta: {
                layout: 'simple'
            },
            component: () => import ( /* webpackChunkName: "ebook-list" */ "@/modules/exercises"),
            props: {
                template: "ExamList"
            }
        },
        {
            path: '/luyen-tap/de-thi/:classId-:subjectId-:id(\\d+)',
            name: 'exerciseExamDetail',
            // meta: { requiresAuth: true },
            meta: {
                layout: 'onlybody',
                hideHeader: true,
                hideFooter: true
            },
            component: () => import ( /* webpackChunkName: "ebook-list" */ "@/modules/exercises"),
            props: {
                template: "ExamDetail"
            },
            query: {
                cauhoi: 1
            }
        },

        // exercise
        {
            path: '/exercise-subject/:slug-:id(\\d+)',
            name: 'exercise-subject',
            // meta: { requiresAuth: true },
            component: () => import ( /* webpackChunkName: "ebook-list" */ "@/modules/exercises"),
            props: {
                template: "ExerciseSubjectDetail"
            }
        },
        // // EBook
        // {
        //     path: '/de-thi',
        //     name: 'exam-list',
        //     // meta: { requiresAuth: true },
        //     component: () =>
        //         import ( /* webpackChunkName: "exam-list" */ "@/modules/exams"),
        //     props: {
        //         template: "ExamList"
        //     }
        // },
        // {
        //     path: '/de-thi/detail',
        //     name: 'exam-detail',
        //     // meta: { requiresAuth: true },
        //     component: () =>
        //         import ( /* webpackChunkName: "exam-list" */ "@/modules/exams"),
        //     props: {
        //         template: "ExamDetail"
        //     }
        // },
        // // Discussion
        // {
        //     path: '/hoi-dap',
        //     name: 'discussion-list',
        //     // meta: { requiresAuth: true },
        //     component: () =>
        //         import ( /* webpackChunkName: "discussion-list" */ "@/modules/discussions"),
        //     props: {
        //         template: "DiscussionList"
        //     }
        // },
        // {
        //     path: '/hoi-dap/detail',
        //     name: 'discussion-detail',
        //     // meta: { requiresAuth: true },
        //     component: () =>
        //         import ( /* webpackChunkName: "discussion-list" */ "@/modules/discussions"),
        //     props: {
        //         template: "DiscussionDetail"
        //     }
        // },
        //Classrooms
        {
            path: '/lop-hoc',
            name: 'ViewListClass',
            // meta: { requiresAuth: true },
            component: () =>
                import ("@/modules/classrooms"),
            props: {
                template: "ViewListClass"
            }
        },
        {
            path: '/lop-hoc/mon-:id/noi-dung',
            name: 'ViewDetailSubject',
            // meta: { requiresAuth: true },
            component: () =>
                import ("@/modules/classrooms"),
            props: {
                template: "ViewDetailSubject"
            }
        },
        {
            path: '/lop-hoc/mon-:id/noi-dung/chi-tiet-:lessonPlanId',
            name: 'ViewDetailSubjectContent',
            // meta: { requiresAuth: true },
            component: () =>
                import ("@/modules/classrooms"),
            props: {
                template: "ViewDetailSubjectContent"
            }
        },
        {
            path: '/lop-hoc/mon-:id/thao-luan',
            name: 'viewDetailDiscuss',
            // meta: { requiresAuth: true },
            component: () =>
                import ("@/modules/classrooms"),
            props: {
                template: "viewDetailDiscuss"
            }
        },
        {
            path: '/lop-hoc/test:1',
            name: 'test',
            // meta: { requiresAuth: true },
            component: () =>
                import ("@/modules/classrooms"),
            props: {
                template: "test"
            }
        },
        {
            path: '/lop-hoc/mon-:id/lich',
            name: 'ViewdetailCalendar',
            // meta: { requiresAuth: true },
            component: () =>
                import ("@/modules/classrooms"),
            props: {
                template: "ViewdetailCalendar"
            }
        },
        {
            path: '/lop-hoc/mon-:id/tai-lieu',
            name: 'ViewDetailDoccument',
            // meta: { requiresAuth: true },
            component: () =>
                import ("@/modules/classrooms"),
            props: {
                template: "ViewDetailDoccument"
            }
        },
        {
            path: '/lop-hoc/lop-:classId/chi-tiet',
            name: 'ViewCodeClass',
            // meta: { requiresAuth: true },
            component: () =>
                import ("@/modules/classrooms"),
            props: {
                template: "ViewCodeClass"
            }
        },
        //Question and Answer
        {
            path: '/hoi-dap/',
            name: 'QA',
            // meta: { requiresAuth: true },
            component: () =>
                import ("@/modules/classrooms"),
            props: {
                template: "ViewCodeClass"
            }
        },
        // Auth
        {
            path: '/dang-xuat',
            name: 'auth-logout',
            meta: {
                layout: 'auth',
                requiresAuth: true
            },
            component: () =>
                import ( /* webpackChunkName: "auth-logout" */ "@/views/auth/Logout"),
        },
        {
            path: '/quen-mat-khau',
            name: 'forgot-password',
            meta: {
                layout: 'simple',
                hideHeader: true,
                hideFooter: false,
                public: true
            },
            component: () =>
                import ("@/views/auth/ForgotPassword"),
        },
        {
            path: '/dang-ky',
            name: 'auth-register',
            meta: {
                layout: 'simple',
                hideHeader: true,
                hideFooter: false,
                public: true
            },
            component: () =>
                import ("@/views/auth/Register_Mobi"),
        },
        {
            path: '/trang-ca-nhan',
            name: 'user-profile',
            meta: {
                layout: 'default',
                requiresAuth: true
            },
            component: () =>
                import ("@/modules/users"),
            props: {
                template: "UserProfile"
            }
        },


        {
            path: '/trang-ca-nhan/hoc-van',
            name: 'Education',
            meta: {
                layout: 'default',
                requiresAuth: true
            },
            component: () =>
                import ("@/modules/users"),
            props: {
                template: "Education"
            }
        },
        {
            path: '/sua-thong-tin-ca-nhan',
            name: 'edit-user-profile',
            meta: {
                layout: 'default',
                requiresAuth: true,
                hideHeader: true
            },
            component: () =>
                import ("@/modules/users"),
            props: {
                template: "EditUserProfile"
            }
        },
        {
            path: '/dang-phat-trien',
            name: 'under-construction',
            meta: {
                layout: 'guest',
                public: true
            },
            component: () =>
                import ("@/views/pages/UnderConstruction"),
        },
        {
            path: '/danh-sach-giao-an',
            name: 'prepareLessonPowerpoint',
            props: {
                template: "PrepareDocList"
            },
            component: () =>
                import ("@/modules/prepare-docs/"),
        },
        {
            path: '/giao-an',
            name: 'prepareLessonPowerpointDetail',
            props: {
                template: "PrepareDocDetail"
            },
            component: () =>
                import ("@/modules/prepare-docs/"),
        },
        {
            path: '/soan-giao-an',
            name: 'prepareLessonAdd',
            props: {
                template: "PrepareDocAdd"
            },
            meta: {
                layout: 'onlybody'
            },
            component: () =>
                import ("@/modules/prepare-docs/"),
        },
        {
            path: '/sua-giao-an/:classId/:subjectId/:id?/:title?',
            name: 'prepareLessonEdit',
            props: {
                template: "PrepareDocEdit"
            },
            meta: {
                layout: 'onlybody'
            },
            component: () =>
                import ("@/modules/prepare-docs/"),
        },
        {
            path: '/soan-de-thi/:id',
            name: 'examAdd',
            props: {
                template: "ExamAdd"
            },
            component: () =>
                import ("@/modules/prepare-docs/"),
        },
        {
            path: '/xem-de-thi/:id',
            name: 'examView',
            props: {
                template: "ExamView"
            },
            meta: {
                layout: 'onlybody'
            },
            component: () =>
                import ("@/modules/prepare-docs/"),
        },
        {
            path: '/danh-sach-de-thi',
            name: 'examList',
            props: {
                template: "ExamList"
            },
            component: () =>
                import ("@/modules/prepare-docs/"),
        },
        {
            path: '/tesst',
            name: 'tesst',
            props: {
                template: "tesst"
            },
            component: () =>
                import ("@/modules/prepare-docs/"),
        },
        {
            path: '/hoi-dap',
            name: 'questionAnswer',
            props: {
                template: "QuestionAnswer"
            },
            component: () =>
                import ("@/modules/prepare-docs/"),
        },
        {
            path: '/quen-mat-khau/mat-khau-moi',
            name: 'newpassword',
            // meta: { requiresAuth: true },
            // meta: { layout: 'default' },
            component: () =>
                import ( /* webpackChunkName: "ebook-list" */ "@/views/auth/NewPassword"),
            // props: {
            //     template: "NewPassword"
            // },
            query: {
                code: 0,
                id: 1
            },
            meta: {
                layout: 'simple',
                hideHeader: true,
                hideFooter: false,
                public: true
            },
        },
        {
            path: '/thong-bao',
            name: 'ViewNoticeAll',
            meta: {
                layout: 'default',
                requiresAuth: true
            },
            component: () =>
                import ("@/modules/notifi"),
            props: {
                template: "ViewNoticeAll"
            }
        },
        {
          path: '/mobile/question-topic/:id',
          name: 'QuestionTopic',
          meta: {
            layout: 'simple',
            hideHeader: true,
            hidefooter: true
          },
          component: () => import ( /* webpackChunkName: "home" */ "@/modules/exercise-mobile"),
          props: {
            template: "QuestionTopic"
          },
          query: {
            token: ''
          }
        },
        {
          path: '/mobile/question/:id',
          name: 'QuestionDetail',
          meta: {
            layout: 'simple',
            hideHeader: true,
            hidefooter: true
          },
          component: () => import ( /* webpackChunkName: "home" */ "@/modules/exercise-mobile"),
          props: {
            template: "ExerciseQuestionDetail"
          },
          query: {
            token: ''
          }
        },
        {
          path: '/mobile/question-guide/:id',
          name: 'QuestionGuideContent',
          meta: {
            layout: 'simple',
            hideHeader: true,
            hidefooter: true
          },
          component: () => import ( /* webpackChunkName: "home" */ "@/modules/exercise-mobile"),
          props: {
            template: "QuestionGuide"
          },
          query: {
            token: ''
          }
        },
        {
          path: '/mobile/exam/:id',
          name: 'ExamDetail',
          meta: {
            layout: 'simple',
            hideHeader: true,
            hidefooter: true
          },
          component: () => import ( /* webpackChunkName: "home" */ "@/modules/exercise-mobile"),
          props: {
            template: "ExerciseExamDetail"
          },
          query: {
            token: ''
          }
        }
        // 404
        // { path: '/404', component: NotFound },
        // { path: '*', redirect: '/404' },
    ]
})

router.afterEach(() => {
    window.scrollTo(0, 0);
});
router.beforeEach((to, from, next) => {
    const authenticated = JWT.getAccessToken();
    const auth = JWT.getAuth();
    const onlyLoggedOut = to.matched.some(record => record.meta.onlyLoggedOut)
    const isPublic = to.matched.some(record => record.meta.public)
    if(to.name=='kiem-tra-xac-thuc'){
        return next();
    }
    if (to.path.includes('mobile')) {
      next();
    } else {
      // Handle link shared -> login for link free
      // if (!authenticated && !auth && to.path !== '/login' && to.path !== '/' && to.query && to.query.shared === window.location.origin) {
      if (!authenticated && !auth && to.path !== '/login' && to.path !== '/') {
          // && to.query.type_show === '1'
          
          store.dispatch('common/setLoading', true);
          return login(EMAIL_PUBLIC, PASS_PUBLIC).then(res => {
              if (!res) {return false;}
              if (res.userProfile) {
                  store.dispatch('auth/setLoginPopupData', res.userProfile)
                  return next({
                      query: {}
                  })
              }
          }).finally(() => store.dispatch('common/setLoading', false))

      } else {
          if (!isPublic && !authenticated && !auth && to.path !== '/login' && to.path !== '/' && !to.meta.guest) {
              // this route requires auth, check if logged in
              // if not, redirect to login page.
              return next({
                      path: '',
                      query: { redirect: to.fullPath }
                  })
                  // }
          }

          if (authenticated && authenticated !== undefined && auth && auth !== null && onlyLoggedOut) {
              return next('/ebook');
          }
          if (to.query) {
              return next({
                  query: to.query
              })
          }
          next();
      }
    }
})

export default router;